(() => {
  const ROOT_SELECTOR = '.xo-cart-discount-collapse';
  const FIELD_SELECTOR = '.teklila-promo-code__field';
  const INPUT_SELECTOR = '.teklila-promo-code__input';
  const APPLY_SELECTOR = '.teklila-promo-code__apply';
  const MESSAGE_SELECTOR = '.teklila-promo-code__message';

  let pendingPromotion = null;

  function getPromoElements(element) {
    const root = element.closest(ROOT_SELECTOR);

    if (!root) {
      return null;
    }

    const field = root.querySelector(FIELD_SELECTOR);
    const input = root.querySelector(INPUT_SELECTOR);
    const apply = root.querySelector(APPLY_SELECTOR);
    const message = root.querySelector(MESSAGE_SELECTOR);

    if (!field || !input || !apply || !message) {
      return null;
    }

    return {
      root,
      field,
      input,
      apply,
      message,
    };
  }

  function clearPromoMessage(root) {
    if (!root) {
      return;
    }

    const field = root.querySelector(FIELD_SELECTOR);
    const input = root.querySelector(INPUT_SELECTOR);
    const message = root.querySelector(MESSAGE_SELECTOR);

    if (field) {
      field.classList.remove('is-error');
    }

    if (input) {
      input.setAttribute('aria-invalid', 'false');
    }

    if (message) {
      message.textContent = '';
      message.hidden = true;
      message.classList.remove('is-info');
    }
  }

  function showPromoMessage(root, text, { info = false } = {}) {
    if (!root) {
      return;
    }

    const field = root.querySelector(FIELD_SELECTOR);
    const input = root.querySelector(INPUT_SELECTOR);
    const message = root.querySelector(MESSAGE_SELECTOR);

    if (!field || !input || !message) {
      return;
    }

    message.textContent = text;
    message.hidden = false;
    message.classList.toggle('is-info', info);

    field.classList.toggle('is-error', !info);
    input.setAttribute('aria-invalid', info ? 'false' : 'true');
  }

  function preparePromotionAttempt(button) {
    const elements = getPromoElements(button);

    if (!elements) {
      return false;
    }

    const { root, input } = elements;
    const value = input.value.trim();

    clearPromoMessage(root);

    if (!value) {
      showPromoMessage(root, 'Enter a promotion code.');

      input.focus({
        preventScroll: true,
      });

      return false;
    }

    const token = {};

    pendingPromotion = {
      root,
      input,
      value,
      token,
    };

    /*
      Prevent a stale attempted code from being associated with
      a later, unrelated discount action.
    */
    window.setTimeout(() => {
      if (pendingPromotion?.token === token) {
        pendingPromotion = null;
      }
    }, 6000);

    return true;
  }

  /*
    Catch Apply before Vows receives the click.

    An empty field is handled locally and never sent to Shopify.
    A non-empty field continues through to Vows' existing
    xo-cart-discount-submit functionality.
  */
  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const button = event.target.closest(APPLY_SELECTOR);

      if (!button) {
        return;
      }

      const canSubmit = preparePromotionAttempt(button);

      if (!canSubmit) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  /*
    Pressing Enter in the promotion field behaves exactly like
    clicking Apply.
  */
  document.addEventListener('keydown', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const input = event.target.closest(INPUT_SELECTOR);

    if (!input || event.key !== 'Enter') {
      return;
    }

    event.preventDefault();

    const root = input.closest(ROOT_SELECTOR);
    const apply = root?.querySelector(APPLY_SELECTOR);

    apply?.click();
  });

  /*
    As soon as the customer begins correcting the code,
    remove the previous validation message.
  */
  document.addEventListener('input', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const input = event.target.closest(INPUT_SELECTOR);

    if (!input) {
      return;
    }

    clearPromoMessage(input.closest(ROOT_SELECTOR));
  });

  /*
    Vows sends failed discount applications to xoToast.

    Intercept only a discount error that originated from our
    TEKLILA promotion field. Other Vows toasts continue to work
    normally.
  */
  function patchDiscountToast() {
    if (
      !window.xoToast ||
      typeof window.xoToast.push !== 'function'
    ) {
      return false;
    }

    if (window.xoToast.__teklilaPromotionInlinePatched) {
      return true;
    }

    const originalPush = window.xoToast.push;

    window.xoToast.push = function (options = {}) {
      const isDiscountError =
        options.className === 'xo-cart-discount-error';

      const hasPendingPromotion =
        pendingPromotion?.root?.isConnected &&
        pendingPromotion?.input?.isConnected;

      if (isDiscountError && hasPendingPromotion) {
        const {
          root,
          input,
          value,
          token,
        } = pendingPromotion;

        const text =
          String(options.content || '').trim() ||
          'This promotion code cannot be applied to this order.';

        const isShippingMessage = /shipping/i.test(text);

        showPromoMessage(root, text, {
          info: isShippingMessage,
        });

        /*
          Vows clears the input after every Apply attempt,
          including failed attempts.

          Restore the customer's code after Vows finishes its
          async handler so they can correct it instead of
          typing the whole code again.
        */
        window.setTimeout(() => {
          if (root.isConnected && input.isConnected) {
            input.value = value;

            if (!isShippingMessage) {
              input.focus({
                preventScroll: true,
              });
            }
          }

          if (pendingPromotion?.token === token) {
            pendingPromotion = null;
          }
        }, 0);

        /*
          Do not send this error through to Vows' coral toast.
        */
        return;
      }

      return originalPush.call(this, options);
    };

    window.xoToast.__teklilaPromotionInlinePatched = true;

    return true;
  }

  /*
    Normally xo-webcomponents has already loaded before this file.
    The retry is only a safety net.
  */
  if (!patchDiscountToast()) {
    let attempts = 0;

    const patchTimer = window.setInterval(() => {
      attempts += 1;

      if (patchDiscountToast() || attempts >= 50) {
        window.clearInterval(patchTimer);
      }
    }, 100);
  }
})();